<div class="page-wrapper">

  <!-- AI Weighted Score Card -->
  <div class="card">
    <div class="card-header">
      <div>
        <h3>AI Weighted Score</h3>
        <p class="subtext">Calculated from {{ThresholdList.length}} questions (excluding Follow-Ups)</p>
      </div>

      <span *ngIf="Recommendation=='Fail'" class="badge fail">Recommendation<br>{{Recommendation}}</span>
      <span *ngIf="Recommendation=='Pass'" class="badge pass">Recommendation<br>{{Recommendation}}</span>
      <span *ngIf="Recommendation=='Follow Up'" class="badge followup">Recommendation<br>{{Recommendation}}</span>


    </div>

    <div class="progress-wrapper">
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="(overAllContribution / thresholdValue)">
        </div>


        <!-- center text -->
        <span class="score-text">
          {{ overAllContribution }} / {{ thresholdValue }}
        </span>
      </div>
    </div>


    <!-- Note -->
    <div class="note">
      <strong>Note:</strong> A mandatory rule was triggered, overriding the weighted score.
    </div>
  </div>

  <!-- Question Score Breakdown -->
  <div class="card">
    <h3 class="section-title">Question Score Breakdown</h3>

    <table class="breakdown-table">
      <thead>
        <tr style="background-color: rgba(0, 0, 0, 0.03);">
          <th width="50%">Question</th>
          <th>Weight</th>
          <th>AI Result</th>
          <!-- <th></th> -->
          <th>Value</th>
          <th>Contribution</th>
        </tr>
      </thead>

      <tbody>

        <tr *ngFor="let item of ThresholdList; let i = index" [ngClass]="{
            'bg-red-50': item.mandatoryRule && !item.isMandatoryPass,
            'bg-green-50': item.mandatoryRule && item.isMandatoryPass
          }">
          <td>
            <span class="dot"></span>

            <span *ngIf="item.mandatoryRule">
              <mat-icon class="small-icon"
                [matTooltip]="item.isMandatoryPass ? 'Mandatory Rule Pass' : 'Mandatory Rule Fail'">
                {{ item.isMandatoryPass ? 'check_circle' : 'cancel' }}
              </mat-icon>
            </span>


            {{item.questionTitle}}
          </td>
          <td><span class="pill">{{item.weight}}</span></td>


          <td *ngIf="item.finalResult == 0">
            <div class="result-wrapper">
              <mat-icon *ngIf="item.isFollowUpFlag && item.followUpFlagResult == 2" class="followup-icon">
                flag
              </mat-icon>

              <span class="status" [ngClass]="{
                'fail': !(item.isFollowUpFlag && item.followUpFlagResult == 2),
                'flag-status': item.isFollowUpFlag && item.followUpFlagResult == 2
              }">
                <mat-icon class="status-icon">cancel</mat-icon>
                <span>Fail</span>
              </span>
            </div>
          </td>

          <td *ngIf="item.finalResult == 1">
            <div class="result-wrapper">
              <mat-icon *ngIf="item.isFollowUpFlag && item.followUpFlagResult == 2" class="followup-icon">
                flag
              </mat-icon>

              <span class="status" [ngClass]="{
                  'pass': !(item.isFollowUpFlag && item.followUpFlagResult == 2),
                  'flag-status': item.isFollowUpFlag && item.followUpFlagResult == 2
                }">
                <mat-icon class="status-icon">check_circle</mat-icon>
                <span>Pass</span>
              </span>
            </div>
          </td>

          <td *ngIf="item.finalResult == 2">
            <div class="result-wrapper">
              <mat-icon *ngIf="item.isFollowUpFlag && item.followUpFlagResult == 2" class="followup-icon">
                flag
              </mat-icon>

              <span class="status" [ngClass]="{
                'follow': !(item.isFollowUpFlag && item.followUpFlagResult == 2),
                'flag-status': item.isFollowUpFlag && item.followUpFlagResult == 2
              }">
                <mat-icon class="status-icon">warning</mat-icon>
                <span>Follow Up</span>
              </span>
            </div>
          </td>

          <!-- <td *ngIf="item.finalResult == 0">
            
            <mat-icon *ngIf="item.isFollowUpFlag && item.followUpFlagResult==2" class="followup-icon">flag</mat-icon>
            <span class="status fail">
              <span class="icon">✖</span>
              Fail
            </span>
          </td>

          <td *ngIf="item.finalResult == 1">
           <mat-icon *ngIf="item.isFollowUpFlag && item.followUpFlagResult==2" class="followup-icon">flag</mat-icon>
            <span class="status pass">
              <span class="icon">✔</span>
              Pass
            </span>
          </td>

          <td *ngIf="item.finalResult == 2">
           <mat-icon *ngIf="item.isFollowUpFlag && item.followUpFlagResult==2" class="followup-icon">flag</mat-icon>
            <span class="status follow">
              <span class="icon">⚠</span>
              Follow Up
            </span>
          </td>  -->


          <td>{{item.value | number:'1.1-1' }}</td>
          <td>
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none"
              stroke="#2f80ed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-trending-up">
              <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
              <polyline points="16 7 22 7 22 13"></polyline>
            </svg>
            {{item.contribution | number:'1.1-1' }}
          </td>
        </tr>

      </tbody>
    </table>
  </div>

</div>